import React, { useEffect, useMemo, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import {
  Calendar,
  ChevronUp,
  FileText,
  PlusCircle,
  RotateCcw,
  Sliders,
  StopCircle,
  User,
} from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../core/redux/action";
import { useDispatch, useSelector } from "react-redux";
import { Filter, MinusCircle } from "react-feather";
import Select from "react-select";
import { DatePicker } from "antd";
import { saleslist } from "../../core/json/saleslistdata";
import Table from "../../core/pagination/datatable";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import AddSupplierTransaction from "./addSupplierTransaction";
import { useGetSupplierTransactionQuery } from "../../core/redux/api/OrderApi";
import { useGetAllSupplierQuery } from "../../core/redux/api/userApi";
import './transaction.css';
import { exportToExcel, exportToPDF } from "../utils/exportUtils2";
const SupplierTransactions = () => {
const isMobile = window.innerWidth < 768;
  const saleslistdata = saleslist;
  const {data: SupplierTransactionsData, isLoading, refetch} = useGetSupplierTransactionQuery(undefined, {
  refetchOnMountOrArgChange: true,
  refetchOnFocus: true
});
  const [exportLoading, setExportLoading] = useState(false);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.rootReducer.toggle_header);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  useEffect(() => {
  refetch();
}, [refetch]);

  const [dateRange, setDateRange] = useState(null);
const [selectedSupplier, setSelectedSupplier] = useState(null);
const [selectedType, setSelectedType] = useState(null);
const [searchText, setSearchText] = useState("");
 const {data: suppliers} = useGetAllSupplierQuery();

// Calculate report statistics
// const reportStats = useMemo(() => {
//   if (!SupplierTransactionsData?.length) return {
//     totalCredit: 0,
//     totalDebit: 0,
//     totalTransactions: 0,
//     netBalance: 0
// }});

//   const totals = SupplierTransactionsData.reduce((acc, transaction) => {
//     if (transaction.type === 'Credit') {
//       acc.totalCredit += transaction.amount || 0;
//     } else {
//       acc.totalDebit += transaction.amount || 0;
//     }
//     return acc;
//   }, { totalCredit: 0, totalDebit: 0 });

//   return {
//     ...totals,
//     totalTransactions: SupplierTransactionsData.length,
//     netBalance: totals.totalCredit - totals.totalDebit
//   };
// }, [SupplierTransactionsData]);

// Filter transactions based on search and filters
const filteredData = useMemo(() => {
  if (!SupplierTransactionsData) return [];
  
  return SupplierTransactionsData.filter(transaction => {
    // Date filter
    if (dateRange?.[0] && dateRange?.[1]) {
      const transactionDate = new Date(transaction.createdAt);
      const startDate = new Date(dateRange[0]);
      const endDate = new Date(dateRange[1]);
      
      if (transactionDate < startDate || transactionDate > endDate) {
        return false;
      }
    }

    // Supplier filter
    if (selectedSupplier && transaction.supplierId?._id !== selectedSupplier._id) {
      return false;
    }

    // Type filter
    if (selectedType && transaction.type !== selectedType.value) {
      return false;
    }

    // Search text
    if (searchText) {
      const searchLower = searchText.toLowerCase();
      const matches = (
        String(transaction.amount).includes(searchLower) ||
        transaction.supplierId?.supplierName?.toLowerCase().includes(searchLower) ||
        transaction.type?.toLowerCase().includes(searchLower) ||
        (transaction.remarks && transaction.remarks.toLowerCase().includes(searchLower))
      );
      return matches;
    }

    return true;
  });
}, [SupplierTransactionsData, searchText, dateRange, selectedSupplier, selectedType]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };
  const flattenTransactionData = (transactions) => {
  return transactions?.map(transaction => ({
    ...transaction,
    supplierName: transaction.supplierId?.supplierName || transaction.supplierId?.supplierName || 'N/A',
  })) || [];
};

  const supplierTransactionColumns = [
    {
      title: "Supplier Name",
      dataIndex: ["supplierId", "supplierName"],
      render: (supplierName, record) => (
        <span>
          {supplierName || record.supplierId?.supplierName || "-"}
        </span>
      ),
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
    
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => a.amount - b.amount,
      render: (amount, record) => (
        <span style={{ color: record.type === 'credit' ? 'green' : 'red' }}>
          {Number(amount).toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
          })}
        </span>
      ),
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (type) => (
        <span style={{ color: type === 'credit' ? 'green' : 'red' }}>
          {type.toUpperCase()}
        </span>
      ),
      filters: [
        { text: 'credit', value: 'credit' },
        { text: 'debit', value: 'debit' },
      ],
      onFilter: (value, record) => record.type === value,
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (date) => (
        <span>{new Date(date).toLocaleDateString()}, {new Date(date).toLocaleTimeString()}</span>
      ),
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      render: (remarks) => remarks || "-",
      responsive: ['sm', 'md', 'lg', 'xl'],
    }
];




const expandable = {
  expandedRowRender: (record) => (
      <div style={{ padding: '10px' }}>
          <p><strong>Type:</strong> <span style={{ color: record.type === 'Credit' ? 'green' : 'red' }}>{record.type}</span></p>
          <p><strong>Date:</strong> {new Date(record.createdAt).toLocaleDateString()}, {new Date(record.createdAt).toLocaleTimeString()}</p>
          <p><strong>Remarks:</strong> {record.remarks || "-"}</p>
      </div>
  ),
  rowExpandable: (record) => true,
  expandRowByClick: true,
  // Only show expand icon on mobile (xs) screens
};


const pdfOptions = {
  title: 'Supplier Transactions Report',
  columns: [
    { key: 'supplierName', header: 'Supplier Name' },
    { key: 'amount', header: 'Amount', format: (val) => `${val?.toFixed(2) }` },
    { key: 'type', header: 'Type' },
    { key: 'date', header: 'Date' },
    { key: 'remarks', header: 'Remarks' }
  ],
  data: filteredData.map(transaction => ({
    supplierName: transaction.supplierId?.supplierName || 'N/A',
    amount: transaction.amount,
    type: transaction.type,
    date: new Date(transaction.createdAt).toLocaleDateString(),
    remarks: transaction.remarks || '-'
  })),
  fileName: 'supplier_transactions_report',
  orientation: 'landscape'
};

const excelOptions = {
  title: 'Supplier Transactions Report',
  columns: [
    { key: 'supplierName', header: 'Supplier Name' },
    { key: 'amount', header: 'Amount', format: (val) => val?.toFixed(2) || '0.00' },
    { key: 'type', header: 'Type' },
    { key: 'date', header: 'Date' },
    { key: 'remarks', header: 'Remarks' }
  ],
  data: filteredData.map(transaction => ({
    supplierName: transaction.supplierId?.supplierName || 'N/A',
    amount: transaction.amount,
    type: transaction.type,
    date: new Date(transaction.createdAt).toLocaleDateString(),
    remarks: transaction.remarks || '-'
  })),
  fileName: 'supplier_transactions',
  sheetName: 'Transactions'
};
  // console.log("supplierdasasdasds",suppliers);
  
    if (isLoading) {
  return <div className="text-center py-5">Loading transactions...</div>;
}

if (!SupplierTransactionsData) {
  return <div className="text-center py-5">No transaction data available</div>;
}
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Supplier Ledger</h4>
                <h6>Manage Your Supplier's Ledger</h6>
              </div>
            </div>
               <ul className="table-top-head">
                          <li>
                            <OverlayTrigger placement="top" overlay={renderTooltip}>
                              <Link
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                
                                  exportToPDF(pdfOptions);
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="PDF Export" />
                              </Link>
                            </OverlayTrigger>
                          </li>
                          <li>
                            <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                              <Link
                                to="#" // Add this to prevent default navigation
                                onClick={(e) => {
                                  e.preventDefault();
                                exportToExcel(excelOptions)}
                                }
                                style={{ cursor: 'pointer' }}
                              >
                                {exportLoading ? (
                                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                ) : (
                                  <ImageWithBasePath src="assets/img/icons/excel.svg" alt="Excel Export" />
                                )}
                              </Link>
                            </OverlayTrigger>
                          </li>
            
                          <li>
                            <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                              <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                <RotateCcw />
                              </Link>
                            </OverlayTrigger>
                          </li>
                          <li>
                            <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                              <Link
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                id="collapse-header"
                                className={data ? "active" : ""}
                                onClick={(e) => {
                                  e.preventDefault();
                                  dispatch(setToogleHeader(!data));
                                }}
                              >
                                <ChevronUp />
                              </Link>
                            </OverlayTrigger>
                          </li>
                        </ul>
           
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-added"
                data-bs-toggle="modal"
                data-bs-target="#add-supplier-transaction"
              >
              <i className='ti ti-circle-plus me-1'></i>
                Add New Transaction
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">














            <div className="card border-0">
  <div className="card-body pb-1">
    <form onSubmit={(e) => e.preventDefault()}>
      <div className="row align-items-end">
        <div className="col-lg-10">
          <div className="row">
            <div className="col-md-4">
              <div className="mb-3">
                <label className="form-label">Date Range</label>
              {isMobile ? (
  <>
    <DatePicker
      className="form-control mb-2"
      placeholder="Start Date"
      onChange={(date) => setDateRange([date, dateRange?.[1]])}
    />
    <DatePicker
      className="form-control"
      placeholder="End Date"
      onChange={(date) => setDateRange([dateRange?.[0], date])}
    />
  </>
) : (
  <DatePicker.RangePicker
    className="form-control"
    onChange={setDateRange}
    style={{ width: '100%' }}
  />
)}
  
              </div>
            </div>
            <div className="col-md-4">
              <div className="mb-3">
                <label className="form-label">Supplier</label>
                <Select
                  classNamePrefix="react-select"
                  options={suppliers}
                  placeholder="All Suppliers"
                  value={selectedSupplier}
                  onChange={setSelectedSupplier}
                  getOptionLabel={(option) => option.supplierName}
                  getOptionValue={(option) => option._id}
                  isClearable
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="mb-3">
                <label className="form-label">Transaction Type</label>
                <Select
                  classNamePrefix="react-select"
                  options={[
                    { value: '', label: 'All Types' },
                    { value: 'Credit', label: 'Credit' },
                    { value: 'Debit', label: 'Debit' }
                  ]}
                  placeholder="All Types"
                  value={selectedType}
                  onChange={setSelectedType}
                  isClearable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-2">
          <div className="mb-3">
            <button 
              className="btn btn-primary w-100" 
              type="button"
              onClick={() => {
                setDateRange(null);
                setSelectedSupplier(null);
                setSelectedType(null);
                setSearchText("");
              }}
            >
              Reset Filters
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
              {/* /Filter */}
























              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <i data-feather="user" className="info-img" />
                        <User className="info-img" />
                        <Select
                          className="img-select"
                          classNamePrefix="react-select"
                          options={suppliers?.supplierName}
                          placeholder="Newest"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <StopCircle className="info-img" />
                        <Select
                          className="img-select"
                          classNamePrefix="react-select"
                          options={status}
                          placeholder="Newest"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <FileText className="info-img" />
                        <input
                          type="text"
                          placeholder="Enter Reference"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <StopCircle className="info-img" />
                        {/* <Select
                          className="img-select"
                          classNamePrefix="react-select"
                          options={paymentstatus}
                          placeholder="Choose Payment Status"
                        /> */}
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Link className="btn btn-filters ms-auto">
                          {" "}
                          <i
                            data-feather="search"
                            className="feather-search"
                          />{" "}
                          Search{" "}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Filter */}
              <div className="table-responsive">
                <Table columns={supplierTransactionColumns} dataSource={filteredData} expandable={expandable}/>
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <>
    
        {/*add popup */}
     <AddSupplierTransaction />
        {/* /add popup */}
    
        {/* edit popup */}
        <div className="modal fade" id="edit-sales-new">
          <div className="modal-dialog edit-sales-modal">
            <div className="modal-content">
              <div className="page-wrapper p-0 m-0">
                <div className="content p-0">
                  <div className="page-header p-4 mb-0">
                    <div className="add-item new-sale-items d-flex">
                      <div className="page-title">
                        <h4>Edit Sales</h4>
                      </div>
                      <button
                        type="button"
                        className="close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-body">
                      <form>
                        <div className="row">
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label>Supplier</label>
                              <div className="row">
                                <div className="col-lg-10 col-sm-10 col-10">
                                  <Select
                                    classNamePrefix="react-select"
                                    options={suppliers}
                                    placeholder="Newest"
                                  />
                                </div>
                                <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                  <div className="add-icon">
                                    <Link to="#" className="choose-add">
                                      <PlusCircle className="plus" />
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label>Sale Date</label>
                              <div className="input-groupicon calender-input">
                              <Calendar className="info-img" />
                                <DatePicker
                                  selected={selectedDate}
                                  onChange={handleDateChange}
                                  type="date"
                                  className="filterdatepicker"
                                  dateFormat="dd-MM-yyyy"
                                  placeholder="Choose Date"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label>Supplier</label>
                              {/* <Select
                                classNamePrefix="react-select"
                                options={suppliername}
                                placeholder="Newest"
                              /> */}
                            </div>
                          </div>
                          <div className="col-lg-12 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label>Product Name</label>
                              <div className="input-groupicon select-code">
                                <input
                                  type="text"
                                  placeholder="Please type product code and select"
                                />
                                <div className="addonset">
                                  <ImageWithBasePath
                                    src="assets/img/icons/scanners.svg"
                                    alt="img"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="table-responsive no-pagination">
                          <table className="table  datanew">
                            <thead>
                              <tr>
                                <th>Product</th>
                                <th>Qty</th>
                                <th>Sale Price(Rs)</th>
                                <th>Discount(Rs)</th>
                                <th>Tax(%)</th>
                                <th>Tax Amount(Rs)</th>
                                <th>Unit Cost(Rs)</th>
                                <th>Total Cost(%)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <div className="productimgname">
                                    <Link
                                      to="#"
                                      className="product-img stock-img"
                                    >
                                      <ImageWithBasePath
                                        src="assets/img/products/stock-img-02.png"
                                        alt="product"
                                      />
                                    </Link>
                                    <Link to="#">Nike Jordan</Link>
                                  </div>
                                </td>
                                <td>
                                  <div className="product-quantity">
                                    <span className="quantity-btn">
                                      +
                                      <PlusCircle/>
                                    </span>
                                    <input
                                      type="text"
                                      className="quntity-input"
                                      defaultValue={2}
                                    />
                                    <span className="quantity-btn">
                                    <MinusCircle/>
                                    </span>
                                  </div>
                                </td>
                                <td>2000</td>
                                <td>500</td>
                                <td>0.00</td>
                                <td>0.00</td>
                                <td>0.00</td>
                                <td>1500</td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="productimgname">
                                    <Link
                                      to="#"
                                      className="product-img stock-img"
                                    >
                                      <ImageWithBasePath
                                        src="assets/img/products/stock-img-03.png"
                                        alt="product"
                                      />
                                    </Link>
                                    <Link to="#">Apple Series 5 Watch</Link>
                                  </div>
                                </td>
                                <td>
                                  <div className="product-quantity">
                                    <span className="quantity-btn">
                                      +
                                      <PlusCircle/>
                                    </span>
                                    <input
                                      type="text"
                                      className="quntity-input"
                                      defaultValue={2}
                                    />
                                    <span className="quantity-btn">
                                    <MinusCircle/>
                                    </span>
                                  </div>
                                </td>
                                <td>3000</td>
                                <td>400</td>
                                <td>0.00</td>
                                <td>0.00</td>
                                <td>0.00</td>
                                <td>1700</td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="productimgname">
                                    <Link
                                      to="#"
                                      className="product-img stock-img"
                                    >
                                      <ImageWithBasePath
                                        src="assets/img/products/stock-img-05.png"
                                        alt="product"
                                      />
                                    </Link>
                                    <Link to="#">Lobar Handy</Link>
                                  </div>
                                </td>
                                <td>
                                  <div className="product-quantity">
                                    <span className="quantity-btn">
                                      +
                                      <PlusCircle/>
                                    </span>
                                    <input
                                      type="text"
                                      className="quntity-input"
                                      defaultValue={2}
                                    />
                                    <span className="quantity-btn">
                                    <MinusCircle/>
                                    </span>
                                  </div>
                                </td>
                                <td>2500</td>
                                <td>500</td>
                                <td>0.00</td>
                                <td>0.00</td>
                                <td>0.00</td>
                                <td>2000</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 ms-auto">
                            <div className="total-order w-100 max-widthauto m-auto mb-4">
                              <ul>
                                <li>
                                  <h4>Order Tax</h4>
                                  <h5>Rs 0.00</h5>
                                </li>
                                <li>
                                  <h4>Discount</h4>
                                  <h5>Rs 0.00</h5>
                                </li>
                                <li>
                                  <h4>Shipping</h4>
                                  <h5>Rs 0.00</h5>
                                </li>
                                <li>
                                  <h4>Grand Total</h4>
                                  <h5>Rs5200.00</h5>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-3 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label>Order Tax</label>
                              <div className="input-groupicon select-code">
                                <input type="text" placeholder={0} />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label>Discount</label>
                              <div className="input-groupicon select-code">
                                <input type="text" placeholder={0} />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label>Shipping</label>
                              <div className="input-groupicon select-code">
                                <input type="text" placeholder={0} />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-6 col-12">
                            <div className="input-blocks mb-5">
                              <label>Status</label>
                              <Select
                                classNamePrefix="react-select"
                                // options={statusupdate}
                                placeholder="Newest"
                              />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="input-blocks">
                              <label>Notes</label>
                              <textarea
                                className="form-control"
                                defaultValue={""}
                              />
                            </div>
                          </div>
                          <div className="col-lg-12 text-end">
                            <button
                              type="button"
                              className="btn btn-cancel add-cancel me-3"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>
                            <Link to="#" className="btn btn-submit add-sale">
                              Submit
                            </Link>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /edit popup */}
        {/* show payment Modal */}
        <div
          className="modal fade"
          id="showpayment"
          tabIndex={-1}
          aria-labelledby="showpayment"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered stock-adjust-modal">
            <div className="modal-content">
              <div className="page-wrapper-new p-0">
                <div className="content">
                  <div className="modal-header border-0 custom-modal-header">
                    <div className="page-title">
                      <h4>Show Payments</h4>
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body custom-modal-body">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="modal-body-table total-orders">
                          <div className="table-responsive">
                            <table className="table  datanew">
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Reference</th>
                                  <th>Amount</th>
                                  <th>Paid By</th>
                                  <th className="no-sort">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>19 Jan 2023</td>
                                  <td>INV/SL0101</td>
                                  <td>Rs1500</td>
                                  <td>Cash</td>
                                  <td className="action-table-data">
                                    <div className="edit-delete-action">
                                      <Link className="me-3 p-2" to="#">
                                        <i
                                          data-feather="printer"
                                          className="feather-rotate-ccw"
                                        />
                                      </Link>
                                      <Link
                                        className="me-3 p-2"
                                        to="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#editpayment"
                                      >
                                        <i
                                          data-feather="edit"
                                          className="feather-edit"
                                        />
                                      </Link>
                                      <Link className="confirm-text p-2" to="#">
                                        <i
                                          data-feather="trash-2"
                                          className="feather-trash-2"
                                        />
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* show payment Modal */}
        {/* Create payment Modal */}
        <div
          className="modal fade"
          id="createpayment"
          tabIndex={-1}
          aria-labelledby="createpayment"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>Create Payments</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body">
                <form>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <label> Date</label>
                        <div className="input-groupicon calender-input ">
                        <Calendar className="info-img" />
                          <DatePicker
                            selected={selectedDate}
                            onChange={handleDateChange}
                            type="date"
                            className="filterdatepicker"
                            dateFormat="dd-MM-yyyy"
                            placeholder="Choose Date"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-12 col-12">
                      <div className="input-blocks">
                        <label>Reference</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-sm-12 col-12">
                      <div className="input-blocks">
                        <label>Received Amount</label>
                        <div className="input-groupicon calender-input">
                          <i data-feather="dollar-sign" className="info-img" />
                          <input type="text" />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-12 col-12">
                      <div className="input-blocks">
                        <label>Paying Amount</label>
                        <div className="input-groupicon calender-input">
                          <i data-feather="dollar-sign" className="info-img" />
                          <input type="text" />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-12 col-12">
                      <div className="input-blocks">
                        <label>Payment type</label>
                        <Select
                          classNamePrefix="react-select"
                          // options={paymenttype}
                          placeholder="Newest"
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="input-blocks">
                        <label>Description</label>
                        <textarea className="form-control" defaultValue={""} />
                        <p>Maximum 60 Characters</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <Link to="#" className="btn btn-submit">
                        Submit
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Create payment Modal */}
        {/* edit payment Modal */}
        <div
          className="modal fade"
          id="editpayment"
          tabIndex={-1}
          aria-labelledby="editpayment"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>Edit Payments</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body">
                <form>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <label>19 Jan 2023</label>
                        <div className="input-groupicon calender-input">
                          <Calendar className="info-img" />
                          <input
                            type="text"
                            className="datetimepicker form-control"
                            placeholder="Select Date"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-12 col-12">
                      <div className="input-blocks">
                        <label>Reference</label>
                        <input type="text" defaultValue="INV/SL0101" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-sm-12 col-12">
                      <div className="input-blocks">
                        <label>Received Amount</label>
                        <div className="input-groupicon calender-input">
                          <i data-feather="dollar-sign" className="info-img" />
                          <input type="text" defaultValue={1500} />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-12 col-12">
                      <div className="input-blocks">
                        <label>Paying Amount</label>
                        <div className="input-groupicon calender-input">
                          <i data-feather="dollar-sign" className="info-img" />
                          <input type="text" defaultValue={1500} />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-12 col-12">
                      <div className="input-blocks">
                        <label>Payment type</label>
                        <select className="react-select">
                          <option>Cash</option>
                          <option>Online</option>
                          <option>Inprogress</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="input-blocks summer-description-box transfer">
                        <label>Description</label>
                        <textarea className="form-control" defaultValue={""} />
                      </div>
                      <p>Maximum 60 Characters</p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="modal-footer-btn mb-3 me-3">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-submit">
                        Save Changes
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* edit payment Modal */}
        <div className="customizer-links" id="setdata">
          <ul className="sticky-sidebar">
            <li className="sidebar-icons">
              <Link
                to="#"
                className="navigation-add"
                data-bs-toggle="tooltip"
                data-bs-placement="left"
                data-bs-original-title="Theme"
              >
                <i data-feather="settings" className="feather-five" />
              </Link>
            </li>
          </ul>
        </div>
      </>
    </div>
  );
};

export default SupplierTransactions;